import React, {  } from 'react';
import { View, Image } from 'react-native';
import { Text } from 'native-base';
import { containerStyle } from 'src/styles/containerStyle';
import { imageStyle } from 'src/styles/imageStyle';
import LoginPageLogo from 'src/assets/login_page_logo.png';

interface InweonLogoProps {
    title: string;
}

export default function InweonLogo(props: InweonLogoProps) {

    return (
        <View style={containerStyle.logoContainer}>
            <Image
                style={imageStyle.inweonLogo}
                source={LoginPageLogo}
            />
            <Text style={{
                fontSize: 20,
                flexWrap: 'wrap'
            }}>
                {props.title || "Welcome to Grams"}
            </Text>
        </View>
    );
}